/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthDeclarationInvalidAliases {
  ACCESSIBILITY_0 = 'accessibility-0',
  APPLICATION_BAR_0 = 'application-bar-0',
  FRAGMENT_FOOTER = 'fragment-footer',
  IMAGE_0 = 'image-0',
  PANEL_0 = 'panel-0',
  PANEL_7 = 'panel-7',
  PANEL_IMG = 'panel-img',
  PANEL_MAIN = 'panel-main',
  PANEL_TEXT = 'panel-text',
  ROOT_COMPONENT = 'root-component',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { HealthDeclarationInvalidAliases };
